import { Container } from '@material-ui/core';
import React from 'react';
import theme from '../../../../theme/MyEirTheme';
import NoticeTile from './NoticeTile';
import styles from './style';

const NoticeTileContainer = props => {
    const classes = styles(theme);
    return (
        <Container maxWidth='md' className={classes.noticeContainer}>
            <NoticeTile
                desktopText={props?.cmsData?.desktopText}
                mobileText={props?.cmsData?.mobileText}
            />
        </Container>
    );
};

export default NoticeTileContainer;
